const USERS_TAG_TYPES = {
  USERS_GET_LIST: "USERS_LIST",
  USERS_CREATE: "USERS_CREATE",
  USERS_EDIT: "USERS_EDIT",
  USERS_DETAIL: "USERS_DETAIL",
  CURRENT_USER: "CURRENT_USER"
};

export const USERS_TAGS = Object.values(USERS_TAG_TYPES);
export default USERS_TAG_TYPES;
